import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donation-setup/events";

export const Route = createFileRoute("/admin/_donation-setup/events")({
  component: Page,
});
